export const ConnectionModule = {
  state: {
    disconnected: false
  },
  actions: {
    setIsConnected({ commit }, isConnected) {
      commit("setIsConnectedRequest", isConnected);
      return isConnected;
    }
  },
  mutations: {
    setIsConnectedRequest(state, isConnected) {
      state.disconnected = !isConnected;
    }
  },
  getters: {
    isConnected(state) {
      return !state.disconnected;
    }
  }
};
